import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=5f70bc20&scoped=true&"
import script from "./UserDropdown.vue?vue&type=script&lang=js&"
export * from "./UserDropdown.vue?vue&type=script&lang=js&"
import style0 from "@/css/componentDropdown.css?vue&type=style&index=0&id=5f70bc20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f70bc20",
  null
  
)

export default component.exports